<template>
  <div>
    <p class="title is-4 pl-2">Facebook Shareable Images</p>
    <!-- <p class="subtitle is-5 pl-2 mb-3">Upload a variety of images. One of them will be picked randomly when a patient clicks "Share to Facebook"</p> -->
    <p class="subtitle is-5 pl-2 mb-3">Upload an image to be shared when a patient clicks "Share to Facebook"</p>
    <fileUpload
      :whiteBG="false"
      uploadType="FACEBOOK_IMAGES"
      labelText="Drag & drop or <span style='text-decoration: underline; cursor: pointer!important;'>browse</span> to upload" 
      fileTypes="image/jpeg, image/png"
    />
    <div class="columns is-multiline is-variable is-1">
      <div class="column is-one-quarter">
        <div v-if="images && images.src" class="is-relative">
          <img :src="images.src" class="image thumbnailShadow" />
          <!-- <b-button @click="confirmDelete(image, idx)" class="is-absolute is-clickable is-danger mt-2 mr-2" icon-right="delete" /> -->
        </div>
      </div>
      <!-- <div v-for="(image, idx) in images" :key="idx" class="column is-one-quarter">
        <div class="is-relative">
          <img :src="image.src" class="image thumbnailShadow" />
          <b-button @click="confirmDelete(image, idx)" class="is-absolute is-clickable is-danger mt-2 mr-2" icon-right="delete" />
        </div>
      </div> -->
    </div>
  </div>
</template>


<script>
import fileUpload from '@/components/fileUpload/upload.vue';
import { mapState } from 'vuex';
import { references, db } from '@/main';

// import firebase from 'firebase/app';
// import 'firebase/storage';

export default {
  name: 'facebookImageUpload',
  components: {
    fileUpload,
  },
  computed: {
    ...mapState({
      practice: state => state.auth.practice,
      images: state => state.auth.practice.facebook_images,
    })
  },
  methods: {
    confirmDelete (image, idx) {
      this.$buefy.dialog.confirm({
        title: `Delete Image`,
        message: `Deleting this image is permanant and cannot be undone. Continue?`,
        type: 'is-danger',
        confirmText: 'Delete',
        onConfirm: () => {
          this.executeDelete(image, idx)
            .then(this.$buefy.toast.open('Image deleted'))
            // .catch(alert('Failed to delete image. Refresh the page and try again.'));
        }
      });
    },
    async executeDelete (image, idx) {
      // remove from the practice's "facebook_images" array
      const facebook_images = JSON.parse(JSON.stringify(this.images)); 
      // force pass by value so we don't try to mutate the firebase observer,
      // vuexfire will handling updating that value in sync with the actual DB
      facebook_images.splice(idx, 1);
      await db.collection(references.practice).doc(this.practice.practice_id).update({ facebook_images });
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  border: solid 0.5px #ededed;
  border-radius: 0.75em;
  width: 20em!important;
  // min-height: 10px;
  // background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));

}
.thumbnailShadow {
  -webkit-box-shadow: inset 0px 0px 12px 0px rgba(0,0,0,0.4);
  -moz-box-shadow: inset 0px 0px 12px 0px rgba(0,0,0,0.4);
  box-shadow: inset 0px 0px 12px 0px rgba(0,0,0,0.4);
}

.is-absolute {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
</style>